import axios from 'axios'
import router from '../router'
import { base64Jiami, getUserInfoCache } from '@/tools/common';

import { Toast } from 'vant';

export const newClient = function () {

  let apiCommon='';
  let token='';
  let userInfo = getUserInfoCache();
  apiCommon = base64Jiami({
    token: userInfo ? userInfo.token : ''
  });
  const newClient = axios.create({
    baseURL: process.env.baseURL,
    timeout: 2*60*1000,
    headers: {
      "systoken": token,
      "api_common":apiCommon,
    },
    withCredentials: true,
  })
  newClient.interceptors.response.use((response) => {
    const data = response.data
    const contentDisposition = response.headers['content-disposition'];
    if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
      // 文件下载
      return response;
    }
    if(data.code === 40003){
      Toast(window.rootApp.$t('m.device_is_more'));
    } else if(data.code === 40006){
      Toast(window.rootApp.$t('m.Operation_failed'));
    } else {
      return response;
    }
  }, (error) => {
    return Promise.reject(error)
  })
  return newClient
}



// WEBPACK FOOTER //
// ./src/api/axios-client-old.js